import { useAuthLinks } from '@/hooks/useAuthLinks';
import { useBreadcrumb } from '@/hooks/useBreadcrumb';
import { useComponentFactory } from '@/hooks/useComponentFactory';
import { useMenuToggle } from '@/hooks/useMenuToggle';
import { useMiniBasket } from '@/hooks/useMiniBasket';
import { useNewsletterSignup } from '@/hooks/useNewsletterSignup';
import { useProductPurchasing } from '@/hooks/useProductPurchasing';

export const SiteApp = () => {
    const authLinks = useAuthLinks();
    const menuToggle = useMenuToggle();
    const miniBasket = useMiniBasket();
    const breadcrumb = useBreadcrumb();
    const purchaseOptions = useProductPurchasing();
    const componentFactory = useComponentFactory();
    const newsletterSignup = useNewsletterSignup();

    return (
        <>
            {authLinks}
            {menuToggle}
            {miniBasket}
            {breadcrumb}
            {purchaseOptions}
            {componentFactory}
            {newsletterSignup}
        </>
    );
};
